export default {
  namespaced: true,
  state: {
    roles: ['super-admin', 'admin', 'user'],
  },
  actions: {
    RESET_STATE() {
      //
    },
  },
  getters: {
    /**
     * Determine whether the user has the correct role to view an element or component
     *
     * @param state
     * @param moduleGetters
     * @param rootState
     * @param rootGetters
     * @returns {function(*): *}
     */
    userHasRole: (state, moduleGetters, rootState, rootGetters) => (roles) => {
      const user = rootGetters['user/user'];

      if (user && user.role) {
        if (typeof roles === 'string') {
          return user.role === roles;
        }

        if (Array.isArray(roles)) {
          return roles.includes(user.role);
        }
      }

      return false;
    },
    userRoles: state => state.roles,
  },
};
